// extracted by mini-css-extract-plugin
export var closeButton = "_d-1";
export var container = "_d-0";
export var fullModalImage = "_d-2";